import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import PdfPageCanvas from './PdfPageCanvas';

const previewWidth = () => Math.min(900, Math.round(window.innerWidth * 0.7));

const PdfSplitterPreview = ({ pdfDoc, pageNumber, numPages, onClose, onPrevious, onNext }) => {
  const [width, setWidth] = useState(previewWidth);

  useEffect(() => {
    const update = () => setWidth(previewWidth());
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <div className="pdf-splitter-preview-overlay" onClick={onClose}>
      <button
        type="button"
        className="pdf-splitter-preview-nav pdf-splitter-preview-nav-prev"
        onClick={(event) => { event.stopPropagation(); onPrevious(); }}
        disabled={pageNumber <= 1}
        title="Previous page"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>

      <div className="pdf-splitter-preview-box" onClick={(event) => event.stopPropagation()}>
        <div className="pdf-splitter-preview-header">
          <span>Page {pageNumber} of {numPages}</span>
          <button type="button" className="pdf-splitter-preview-close" onClick={onClose} title="Close (Esc)">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="pdf-splitter-preview-scroll">
          <PdfPageCanvas pdfDoc={pdfDoc} pageNumber={pageNumber} width={width} />
        </div>
      </div>

      <button
        type="button"
        className="pdf-splitter-preview-nav pdf-splitter-preview-nav-next"
        onClick={(event) => { event.stopPropagation(); onNext(); }}
        disabled={pageNumber >= numPages}
        title="Next page"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default PdfSplitterPreview;
